import { useOutletContext } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import type { District } from '@/models/district';
import type { Region } from '@/models/region';

interface TerritoryContext {
  district: District | null;
  region: Region | null;
  isDistrict: boolean;
}

export default function ChurchesTab() {
  // Context available for future use
  useOutletContext<TerritoryContext>();
  
  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mx-auto flex size-20 items-center justify-center rounded-full bg-muted">
          <Building2 className="size-10 text-muted-foreground" />
        </div>
        <h2 className="mt-6 text-2xl font-bold">Churches Module</h2>
        <p className="mt-3 text-muted-foreground">
          This module is currently under development. Church management features will be available soon.
        </p>
        <div className="mt-8 rounded-lg border border-border bg-card p-4">
          <p className="text-sm text-muted-foreground">
            Future features will include:
          </p>
          <ul className="mt-3 space-y-2 text-left text-sm text-muted-foreground">
            <li className="flex items-center gap-2">
              <div className="size-1.5 shrink-0 rounded-full bg-primary" />
              Church directory and contact information
            </li>
            <li className="flex items-center gap-2">
              <div className="size-1.5 shrink-0 rounded-full bg-primary" />
              Pastor assignments and history
            </li>
            <li className="flex items-center gap-2">
              <div className="size-1.5 shrink-0 rounded-full bg-primary" />
              Membership statistics and reports
            </li>
            <li className="flex items-center gap-2">
              <div className="size-1.5 shrink-0 rounded-full bg-primary" />
              Church activity and event tracking
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
